import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Box,
  Grid,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import useRequest from '@hooks/useRequest';
import useUserActionLog, {
  Enum_Action_Page_Enum,
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import { useRequestProcessMethodStyles } from './styles';
import ServiceTypes from './ServiceTypes';
import RequestProcessMethodCard from './RequestProcessMethodCard';
import { CapaQuotationServiceType } from '@generated/graphql';
import { requestEnumToString } from '@utils/enumToString';
import useQueryString from '@hooks/useQueryString';
import { RequestQueryString } from '@routes/NewRequest/types';
import { UploadedDrawingFileType } from '@modules/request/types';

interface Props {
  reWrite: boolean;
  uploadedDrawingFiles: UploadedDrawingFileType[];
}
const RequestProcessMethodPresenter = ({
  reWrite,
  uploadedDrawingFiles
}: Props) => {
  const { requestState, onUpdateRfqInfo, onInitRfqState } = useRequest();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useRequestProcessMethodStyles();
  const history = useHistory();
  const { onInsertUserActionLogOne } = useUserActionLog();
  const {
    query: { serviceType },
    onAddQueryString
  } = useQueryString<RequestQueryString>();

  React.useEffect(() => {
    if (requestState.serviceType !== CapaQuotationServiceType.Design) {
      const logKey = `Page_RFQ_${requestState.serviceType}_ProcessMethod` as keyof typeof Enum_Action_Page_Enum;
      onInsertUserActionLogOne(
        Enum_Action_Page_Enum[logKey],
        CapaActivityType.PageVisit
      );
    }
  }, [requestState.serviceType, onInsertUserActionLogOne]);

  return (
    <Container maxWidth="md" className={classes.container}>
      <Grid container className={classes.root} id="CNC">
        <CustomizedTypography
          fontWeight="700"
          variant={matches ? 'h3' : 'h2'}
          gutterBottoms={40}
          align={matches ? 'center' : 'inherit'}
        >
          <span className={classes.span}>
            {requestEnumToString(serviceType)}
          </span>
          의{matches && <br />}&nbsp; 세부 가공방식을 선택하세요*
        </CustomizedTypography>
        <Box className={classes.itemRoot}>
          {ServiceTypes(serviceType).map((method) => {
            return (
              <RequestProcessMethodCard
                key={method.id}
                name={method.name}
                src={method.src}
                onClick={() => {
                  onUpdateRfqInfo({
                    detailedServiceType: method.serviceEnum,
                    uploadedDrawingFiles: reWrite
                      ? uploadedDrawingFiles
                      : undefined
                  });
                  onAddQueryString({
                    detailedServiceType: method.serviceEnum
                  });
                }}
                toBlog={(e) => {
                  onInsertUserActionLogOne(
                    Enum_Action_Button_Enum.Button_RFQ_CNC_About_ProcessMethod,
                    CapaActivityType.ButtonClick
                  );
                  e.stopPropagation();
                  window.open(method.url);
                }}
              />
            );
          })}
        </Box>
      </Grid>
      {!reWrite && (
        <Grid container alignItems="center" justifyContent="center">
          <CustomizedButton
            variant="outlined"
            color="inherit"
            classes={{ outlined: classes.prevBtn, label: 'label' }}
            onClick={() => {
              onInitRfqState();
              history.push('/request');
            }}
          >
            이전 단계
          </CustomizedButton>
        </Grid>
      )}
    </Container>
  );
};

export default RequestProcessMethodPresenter;
